// Multi-business selection for the sidebar switcher (any subset of the
// user's businesses). Saved per user in localStorage. While two or more are
// chosen, every GET without its own business_id carries business_ids=...;
// the server intersects it with the user's access, so it can never widen it.
const key = (userId) => `selectedBusinessIds:${userId || 'anon'}`;
let active = [];
const listeners = new Set();

export function readSavedMulti(userId) {
  try {
    const raw = JSON.parse(localStorage.getItem(key(userId)) || '[]');
    return Array.isArray(raw) ? raw.map(Number).filter((n) => Number.isInteger(n) && n > 0) : [];
  } catch { return []; }
}

export function saveMulti(userId, ids) {
  try { localStorage.setItem(key(userId), JSON.stringify(ids)); } catch {}
}

// Only a real subset (2+) is "multi"; 0 = All and 1 = single use the old path.
export function setActiveBusinessIds(ids) {
  const next = ids && ids.length >= 2 ? [...new Set(ids.map(Number))].sort((a, b) => a - b) : [];
  if (next.join(',') === active.join(',')) return;
  active = next;
  listeners.forEach((fn) => fn(active));
}

export const activeBusinessIds = () => active;

const installed = new WeakSet();
export function installBusinessIds(client) {
  if (!client || !client.interceptors || installed.has(client)) return;
  installed.add(client);
  client.interceptors.request.use(withBusinessIds);
}
export function subscribeBusinessIds(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// axios request hook: GET only, and never when the request names a business.
export function withBusinessIds(config) {
  if (!active.length || String(config.method || 'get').toLowerCase() !== 'get') return config;
  // The switcher list, sign-in and admin screens are never narrowed.
  if (/^\/?(businesses|auth|app-config|admin|business-invites|page-visibility|notifications|system|2fa)(\/|\?|$)/.test(String(config.url || ''))) return config;
  const params = config.params || {};
  const named = (params.business_id !== undefined && params.business_id !== null && params.business_id !== '')
    || params.business_ids !== undefined || /[?&]business_ids?=/.test(String(config.url || ''));
  if (named) return config;
  return { ...config, params: { ...params, business_ids: active.join(',') } };
}
